(function (angular) {
  'use strict';

  angular
    .module('bossApp.login')
    .factory('loginService', loginService);

  loginService.$inject = ['$log', '$http', 'URLS','requestHeadersService', '$q', '$filter'];

  function loginService($log, $http, URLS, requestHeadersService, $q, $filter) {

    return {
      loginRequest: _loginRequest,
      logoutRequest: _logoutRequest
    };

    function _logoutRequest(params) {
      return _sendRequestForm({
        config: URLS.urlLogout,
        params: params
      }, '');
    }

    // Esta metodo devuelve una promose, then si valido, catch si invalido
    function _loginRequest(params) {
      return _sendRequestForm({
        config: URLS.urlLogin,
        params: _mapLoginData(params)
      }, '')
      .then(function (responseObj) {
        // si la respuesta es correcta tenemos que ver si ha devuelto error
        var error = undefined;
        $log.debug('login then', responseObj);
        var response = responseObj.data;
        var eai = response.indexOf("enviar('");
        if (eai !== -1) {
          // Si encontramos un error
          var eaiFin = response.indexOf("')", eai);
          var eaiError = response.substring(eai + "enviar('".length, eaiFin);
          // modificamos la respuesta con la informacion correcta
          responseObj.error= eaiError;
          // rechazamos que el servicio use el catch
          return $q.reject(responseObj);
        }
      })
      .then(checkErrorDuplicatedEntity)
      // Todos los errores pasan por aquí.
      // Esta funcion debe develover un string codigo de error traducido de i18n\boss-locale-es.json
      .catch(function (responseObj) {
        $log.debug('login catch', responseObj);
        var error = responseObj.error || 'default';
        var errorInfo = {};

        if (responseObj && responseObj.data && (responseObj.data['error-code'] === 'duplicatedEntity')) {
          error = 'USERDUPLICATED'
        }

        if(error === 'EAI0000') {
          URLS.setError = true;
          error = 'WARNING';
        } else {
          URLS.setError = false;
        }  

        if (responseObj && responseObj.data && (responseObj.data['error-code'] === 'rts')) {
          error = 'rts';
        }

        if(responseObj && responseObj.data && responseObj.data.data && responseObj.data.data.indexOf('Error el usuario no es administrador solidario') > -1) {
          error = 'no-administrador-solidario';
        }

        var errorKey = 'boss-bossError-code-' + error;
        errorInfo.errorMsg = $filter('translate')(errorKey);

        if (error === "rts") errorInfo.errorRTS = true;

        // Si no existe traduccion para el error usamos el generico
        if (errorKey == errorInfo.errorMsg) {
        	errorInfo.errorMsg = $filter('translate')('boss-bossError-code-default');
        }
        return $q.reject(errorInfo)
      })

    function checkErrorDuplicatedEntity() {
      // return $http.post(location.origin + '/SESKYTA/kyta_mult_web_netcashservices_01/services/restBoss/BossServices/getContextualData')
      return $http(
        {
          method: 'post',
          url:location.origin + '/SESKYTA/kyta_mult_web_netcashservices_01/services/restBoss/BossServices/getContextualData',
          params : {
            altaUsuario: false
          }
        })
      .then(function (response) {
        var usuario;
        var poderes = false;
        var esAdmin = false;
        var rtsError = false;
        response.error = '';
        response.status = 500;
        try {
          usuario = response.data.respuestaContextoCashEurasiaDTO.contextoCashEurasiaDTO.Usuario
          poderes = (usuario.poderValida === 'S');
          esAdmin = (usuario.esAdministrador === 'S');
        } catch (e) {
          // Error no controlado
          rtsError = true;
          response.error = 'rts';
          return $q.reject(response);
        } finally {
          if (poderes && esAdmin) {
            return usuario;
          } else if(!rtsError){
            response.status= 403;
            response.error= 'no-administrador-solidario';
            return $q.reject(response)
          }
        }
      })
    }
  }

    //envía la peticion mediante $http
    function _sendRequestForm(eOpts, getParams) {
      var configParam = eOpts.config;
      var method = configParam.method;
      var url = configParam.url;
      var parameters = eOpts.params;
      if (angular.isDefined(configParam.mock) && configParam.mock === true) {
        url = configParam.urlMock;
      }

      return $http({
        method: method,
        url: location.origin + url + getParams,
        //headers: requestHeadersService(),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        crossDomain: eOpts.crossDomain,
        transformRequest: function(obj) {
            var str = [];
            for(var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
        },
        data: parameters
      });
    }

    //envía la peticion mediante $http.
    function _sendRequest(eOpts, getParams) {
      var configParam = eOpts.config;
      var method = configParam.method;
      var url = configParam.url;
      var parameters = eOpts.params;
      if (angular.isDefined(configParam.mock) && configParam.mock === true) {
        url = configParam.urlMock;
      }

      return $http({
        method: method,
        url: url + getParams,
        headers: requestHeadersService(),
        crossDomain: eOpts.crossDomain,
        data: parameters
      });
    }

    function _mapLoginData(_params) {
      // creamos una copia para no mutar datos
      var params = angular.copy(_params)
    	// $log.log(params);
    	var company = params.cod_emp.toUpperCase();
    	var userCode = params.cod_usu.toUpperCase();
    	//var userPassword = params.eai_password.toUpperCase();
    	var userPassword = params.eai_password;
      var channel = "0023";
      var intBank = "0001";

    	params.eai_user = channel + intBank + company + userCode;
    	params.cod_emp = company;
    	params.cod_usu = userCode;
    	params.eai_password = userPassword;

    	// $log.log('login params ', params);
    	return params;
    }
  }
})(angular);
